<ndt-banned-provisioning-ip-register-view
   [callState]="callState$ | async"
   [dataSource]="dataSource$ | async"
   [hasNextPage]="hasNextPage$ | async"
   [pagingCallState]="pagingCallState$ | async"
   [totalCount]="totalCount$ | async"
   [name]="entityName"
   [columns]="columns"
   (loadMore)="onLoadMore()"
   (quickFilterChange)="onQuickFilterChange($event)"
   (allowIp)="onAllowIp($event)"
   (unbanIp)="onUnbanIp($event)"
   (orderingOptionsChange)="onOrderingOptionsChange($event)"
   [orderingOptions]="orderingOptions$ | async"
></ndt-banned-provisioning-ip-register-view>
